// SVG Path Validation Utility
function validateSvgPath(pathData) {
    if (!pathData || typeof pathData !== 'string') {
        return false;
    }
    
    // Check for empty or whitespace-only paths
    if (!pathData.trim()) {
        return false;
    }
    
    // Basic validation for arc flags (should be 0 or 1)
    const arcFlagPattern = /A\s*[^01]*[^\s01,][^01]*[^\s01,]/g;
    const matches = pathData.match(arcFlagPattern);
    
    if (matches) {
        return false;
    }
    
    // Check for obviously malformed paths
    if (pathData.includes('M0,0 L10,10 L0,10 Z')) {
        return false;
    }
    
    // Check for path data with only whitespace or single points
    const pathTrimmed = pathData.trim();
    if (pathTrimmed.length < 5) {
        return false;
    }
    
    return true;
}

// Fix SVG paths on page load and after Livewire navigation
function fixSvgPaths() {
    const svgPaths = document.querySelectorAll('svg path[d]');
    
    svgPaths.forEach(path => {
        const pathData = path.getAttribute('d');
        if (!validateSvgPath(pathData)) {
            // Don't modify theme toggle icons
            const parentSvg = path.closest('svg');
            if (parentSvg && (parentSvg.id === 'theme-toggle-dark-icon' || parentSvg.id === 'theme-toggle-light-icon')) {
                return;
            }
            
            // Don't modify sidebar menu icons
            const sidebarMenuItem = path.closest('li a[wire\\:navigate]');
            if (sidebarMenuItem) {
                return;
            }
            
            // Don't modify icons in buttons or nav
            const buttonOrNav = path.closest('button, nav, .nav-item, .menu-item');
            if (buttonOrNav) {
                return;
            }
            
            // Hide the element instead of removing to avoid breaking layout
            path.style.display = 'none';
        }
    });
}

// Suppress SVG transform errors from ApexCharts
const originalSetAttribute = SVGElement.prototype.setAttribute;
SVGElement.prototype.setAttribute = function(name, value) {
    if (name === 'transform' && typeof value === 'string' && value.includes('NaN')) {
        return;
    }
    return originalSetAttribute.call(this, name, value);
};

// Run on DOMContentLoaded
document.addEventListener('DOMContentLoaded', fixSvgPaths);

// Run after Livewire navigation
document.addEventListener('livewire:navigated', fixSvgPaths);

// Also run periodically to catch dynamically loaded content
document.addEventListener('livewire:updated', fixSvgPaths);

// Export for use in other modules
window.validateSvgPath = validateSvgPath;